import { useVehicle } from '../vehicle-context';

const usePreview = useVehicle;

export {
  usePreview,
};

export default null;
